import { gridPropsOverride, MAX_LIMIT } from '../../constants';
import { WidgetPropsI } from '../../types';

export const normalizeLoadMoreProps = (props: WidgetPropsI): WidgetPropsI => {
  if (!props.showLoadMore || !props.shouldLimitImages) {
    return props;
  }

  let mediasOnInitialLoad = Math.max(1, props.mediasOnInitialLoad);
  let mediasOnLoadMore = Math.max(1, props.mediasOnLoadMore);

  if (mediasOnInitialLoad + mediasOnLoadMore <= MAX_LIMIT) {
    return {
      ...props,
      mediasOnInitialLoad,
      mediasOnLoadMore,
    };
  }

  if (mediasOnInitialLoad >= MAX_LIMIT) {
    mediasOnInitialLoad = Math.floor(MAX_LIMIT / 2);
  }

  mediasOnLoadMore = MAX_LIMIT - mediasOnInitialLoad;

  return {
    ...props,
    mediasOnInitialLoad,
    mediasOnLoadMore,
  };
};

export const resolveWidgetProps = (
  props: WidgetPropsI,
  isMobile: boolean,
  isGrid: boolean,
): WidgetPropsI => {
  const {
    showLoadMore_m,
    mediasOnInitialLoad_m,
    mediasOnLoadMore_m,
    shouldLimitImages_m,
    ...restOfProps
  } = props;
  const updatedProps = { ...restOfProps } as WidgetPropsI;

  if (isMobile) {
    updatedProps.mediasOnInitialLoad = mediasOnInitialLoad_m;
    updatedProps.showLoadMore = showLoadMore_m;
    updatedProps.shouldLimitImages = isGrid ? true : shouldLimitImages_m;
    updatedProps.mediasOnLoadMore = mediasOnLoadMore_m;
  }

  return normalizeLoadMoreProps(updatedProps);
};

export const getGridOverride = (isGrid: boolean) => {
  return isGrid ? gridPropsOverride : {};
};
